(() => {
  'use strict';
  const quote = value => '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  function query(term) {
    const value = term.trim();
    if (!value) return '';
    if (/\b(?:title|vendor|product_type|variants\.sku|tag|body):/i.test(value)) return value;
    // Verified storefront vendor identities for these approved bare line codes.
    // A phrase such as "Ram TRX" continues through the full text query below.
    const codeVendors = { TRX: 'Truxedo', FIA: 'FIA', CUR: 'CURT', ACC: 'ACI', DRF: 'Dura-Flip' };
    if (Object.prototype.hasOwnProperty.call(codeVendors, value.toUpperCase())) return 'vendor:' + quote(codeVendors[value.toUpperCase()]);
    const aliases = window.TruckOutfittersSku?.searchAliases(value) || [];
    if (aliases.length > 1 || /^[A-Z0-9]{3,}_[\s\S]+$/.test(value)) return [...new Set(aliases.length ? aliases : [value])].map(sku => 'variants.sku:' + quote(sku)).join(' OR ');
    if (/^[A-Za-z0-9][A-Za-z0-9._/-]*$/.test(value) && /\d/.test(value)) {
      return '(tag:' + quote('MPN:' + value) + ' OR variants.sku:' + quote(value) + ' OR title:' + quote(value) + ' OR product_type:' + quote(value) + ')';
    }
    const words = value.match(/[^\s]+/g) || [];
    return words.map(word => '(' + ['title', 'product_type', 'vendor'].map(field => field + ':' + quote(word)).join(' OR ') + ')').join(' AND ');
  }
  function searchUrl(term, base = location.href) {
    const url = new URL(base, location.origin);
    url.pathname = (window.Shopify?.routes?.root || '/') + 'search';
    ['page', 'section_id', 'sections', 'q', 'keyword'].forEach(key => url.searchParams.delete(key));
    url.searchParams.set('q', query(term));
    url.searchParams.set('keyword', term.trim());
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    return url;
  }
  window.TruckKeywordSearch = Object.freeze({ query, searchUrl });
  function initialize() {
    const original = new URL(location.href).searchParams.get('keyword');
    const forms = [...document.querySelectorAll('form[role="search"]')];
    for (const form of forms) {
      const input = form.querySelector('input[name="q"]');
      if (!input || form.dataset.keywordReady) continue;
      form.dataset.keywordReady = 'true';
      if (original != null && location.pathname.endsWith('/search')) input.value = original;
      form.addEventListener('submit', event => {
        if (!input.value.trim()) return;
        event.preventDefault();
        location.assign(searchUrl(input.value).toString());
      });
    }
    if (original != null && location.pathname.endsWith('/search')) {
      const count = document.querySelector('.search-result-count');
      if (count && !count.textContent.includes('1,000+')) count.textContent = count.textContent.split(' results for ')[0] + ' results for “' + original + '”';
      document.title = 'Search: ' + original + ' | Truck Outfitters';
    }
    const root = document.querySelector('[data-predictive-search]');
    const input = root?.querySelector('[data-predictive-search-input]');
    const results = root?.querySelector('[data-predictive-search-results]');
    if (!input || !results || root.dataset.keywordReady) return;
    root.dataset.keywordReady = 'true';
    let timer, controller;
    const close = () => { results.hidden = true; results.replaceChildren(); input.setAttribute('aria-expanded', 'false'); };
    async function suggest(term) {
      controller?.abort(); controller = new AbortController();
      const url = searchUrl(term); url.searchParams.set('section_id', 'main-search');
      try {
        const response = await fetch(url, { signal: AbortSignal.any([controller.signal, AbortSignal.timeout(10000)]) });
        if (!response.ok) throw new Error('Search unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (input.value.trim() !== term) return;
        const list = document.createElement('ul'); list.className = 'predictive-search-list'; list.setAttribute('role', 'listbox');
        for (const card of [...parsed.querySelectorAll('.product-card')].slice(0, 8)) {
          const source = card.querySelector('a.product-card-link'); if (!source) continue;
          const li = document.createElement('li'); li.setAttribute('role', 'option');
          const link = document.createElement('a'); link.className = 'predictive-search-item'; link.href = source.href;
          const image = document.createElement('span'); image.className = 'predictive-search-image';
          const img = card.querySelector('img'); if (img) image.append(img.cloneNode(true));
          const copy = document.createElement('span'); copy.className = 'predictive-search-copy';
          for (const [selector, tag] of [['small','small'], ['h3','strong'], ['.part-number','span']]) {
            const sourceText = card.querySelector(selector); if (sourceText) { const node = document.createElement(tag); node.textContent = sourceText.textContent; if (tag === 'strong') node.className = 'predictive-search-title'; copy.append(node); }
          }
          const price = card.querySelector('[data-sale-price]')?.cloneNode(true) || card.querySelector('.product-bottom strong')?.cloneNode(true);
          if (price) price.classList.add('predictive-search-price');
          link.append(image, copy); if (price) link.append(price); li.append(link); list.append(li);
        }
        const all = document.createElement('a'); all.className = 'predictive-search-all'; all.href = searchUrl(term).toString(); all.textContent = JSON.parse(document.querySelector('[data-keyword-copy]')?.textContent || '{}').allResults || term;
        results.replaceChildren(list, all); results.hidden = false; input.setAttribute('aria-expanded', 'true');
      } catch (error) { if (error.name !== 'AbortError') close(); }
    }
    input.addEventListener('input', () => { clearTimeout(timer); controller?.abort(); const term = input.value.trim(); if (term.length < 2) return close(); timer = setTimeout(() => suggest(term), 250); });
    input.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
    document.addEventListener('click', event => { if (!root.contains(event.target)) close(); });
  }
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();

